import { TeamColor } from '../models/interfaces/TeamAttributes';

export function parseTeamColor(teamColor: TeamColor, alpha: Number = 1): string {
    return `rgba(${teamColor.red * 255},${teamColor.green * 255},${teamColor.blue * 255},${alpha})`;
}
